// extracted by mini-css-extract-plugin
module.exports = {"title":"_0601e59e","chips":"_afc8a1df","informing":"_8da3c1d1"};